export default {
  pagination: {},
  funnel: null,
  funnels: []
};
